
import {
  Component,
  Vue
} from 'vue-property-decorator'
import {
  apiSystemlogListV2,
  apiSystemlogListV2Data
} from '@/api/setting'
import {
  RequestPaging
} from '@/utils/util'
import LsPagination from '@/components/ls-pagination.vue'
import ExportData from '@/components/export-data/index.vue'
	@Component({
	  components: {
	    LsPagination,
	    ExportData
	  }
	})
export default class Journal extends Vue {
  /** S Data **/

		pickerOptions = {
		  shortcuts: [{
		    text: '最近一周',
		    onClick (picker: any) {
		      const end = new Date()
		      const start = new Date()
		      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
		      picker.$emit('pick', [start, end])
		    }
		  },
		  {
		    text: '最近一个月',
		    onClick (picker: any) {
		      const end = new Date()
		      const start = new Date()
		      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
		      picker.$emit('pick', [start, end])
		    }
		  },
		  {
		    text: '最近三个月',
		    onClick (picker: any) {
		      const end = new Date()
		      const start = new Date()
		      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
		      picker.$emit('pick', [start, end])
		    }
		  }
		  ]
		}

		tableData: Array<object> = [];

		pager: RequestPaging = new RequestPaging()

		// 查询表单
		form: any = {
		  admin_name: '', // 管理员
		  url: '', // 访问链接
		  ip: '', // 来源IP
		  type: '', // 访问方式
		  start_time: '', // 日志时间开始
		  end_time: '', // 日志时间结束
		  is_http_run_sn_file: '0',
		  is_http_error_sn_file: '0',
		  is_http_end_sn_file: '0'
		}

		http_run_sn='';
		http_error_sn='';
		http_end_sn='';
		activeName_='http_run_sn';
		dialogVisible = false;
		title_name = ''
		click_id = 0

		$refs!: { formRef: any }

		apiSystemlogListV2 = apiSystemlogListV2
		/** E Data **/

		/** S Methods **/
		// 获取日志列表数据
		getJournalList () {
		  // 分页请求
		  this.pager
		    .request({
		      callback: apiSystemlogListV2,
		      params: this.form
		    })
		}

		// 重置按钮
		onReset () {
		  for (const key in this.form) {
		    this.$set(this.form, key, '')
		  }
		  this.getJournalList()
		}

		// 拆分时间
		splitTime () {
		  console.log(this.tableData)
		  if (this.tableData != null) {
		    this.form.start_time = this.tableData[0]
		    this.form.end_time = this.tableData[1]
		  }
		}

		showFileInfo (id:any, type:any) {
		  if (type) {
		    this.activeName_ = type
		  }
		  this.title_name = `数据id：${id}`
		  this.http_run_sn = ''
		  this.http_error_sn = ''
		  this.http_end_sn = ''
		  this.click_id = id
		  apiSystemlogListV2Data({ id: id }).then((data) => {
		    console.log(data)
		    this.title_name = `数据id：${data.id},创建时间：${data.create_time},编号：${data.http_run_sn}`
		    this.http_run_sn = data.http_run_sn_data
		    this.http_error_sn = data.http_error_sn_data
		    this.http_end_sn = data.http_end_sn_data
		    this.dialogVisible = true
		  })
		}

		/** E Methods **/

		/** S Life Cycle **/
		created () {
		  this.getJournalList()
		}
		/** E Life Cycle **/
}
